<template>
	<v-card flat rounded="0">
		<v-card-title primary-title>
			<v-row dense justify="space-between">
				<v-col cols="12" sm="8">
					<div
						v-if="$vuetify.breakpoint.mdAndDown"
						:class="`primary--text text-overline ml-2 ${
							$vuetify.breakpoint.xs ? 'text-center' : ''
						}`"
					>
						Seguimiento estado general ofertas
					</div>
					<div
						v-else
						class="font-weight-light primary--text text-h4 ml-2 text-capitalize"
					>
						Seguimiento estado general ofertas
					</div>
				</v-col>
				<v-col
					sm="4"
					cols="12"
					:class="`d-flex align-center ${
						$vuetify.breakpoint.xs
							? 'justify-center'
							: 'justify-end'
					}`"
				>
				</v-col>
			</v-row>
		</v-card-title>
		<!-- <v-divider class="test"></v-divider> -->
		<v-card-text>
			<v-data-table
				:headers="headers"
				:items="filteredOffers"
				:search="search"
				:item-class="getRowClass"
			>
				<template v-slot:item.cliente="{ item }">
					<v-tooltip
						v-if="item.cliente"
						max-width="470px"
						top
					>
						<template v-slot:activator="{ on, attrs }">
							<div
								class="d-flex justify-space-between"
								v-bind="attrs"
								v-on="on"
							>
								<div>
									{{ item.cliente.substr(0, 21) }}
									...
								</div>
								<v-icon>mdi-message-reply-text-outline</v-icon>
							</div>
						</template>
						<span class="pa-2 text-justify">{{
							item.cliente
						}}</span>
					</v-tooltip>
				</template>
				<template v-slot:item.offerId="{ item }">
					<div class="d-flex align-center">
						{{ item.offerId }}
						<v-icon v-if=" statesIds[item.id_estado]['text'] == 'Presentada'" @click="openDetailedView(item)">mdi-open-in-new</v-icon>
					</div>
				</template>
				<template v-slot:item.created_date="{ item }">
					{{ formatDate(item.created_date) }}
				</template>
				<template v-slot:item.vodafone_date="{ item }">
					{{ formatDate(item.vodafone_date) }}
				</template>
				<template v-slot:item.idOrden="{ item }">
					<div v-if="item.idOrden" class="d-flex align-center">
						{{ item.idOrden }}
						<v-icon @click="detailOfferDetail(item)">mdi-open-in-new</v-icon>
					</div>
				</template>
				<template v-slot:item.id_estado="{ item }">
					<div class="d-flex align-center">
						{{ statesIds[item.id_estado]['text'] }}
					</div>
				</template>
				<template v-slot:item.ot_lastupdate="{ item }">
					{{ formatDateLarge(item.ot_lastupdate) }}
				</template>
			</v-data-table>

			<PieChart :chart-data="pieData" :options="optionsPieChart" />
		</v-card-text>
		<OfferDetailBase />
	</v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { formatDate, formatDateLarge } from '@/util/libUtil.js';
import statesIds from '@/util/retailX/offerStates.js';
import PieChart from '@/components/GerenciaTeletrabajo/Stats/PieChart.js';
import OfferDetailBase from '@/components/RetailX/OfferDetail/OfferDetailBase.vue';

export default {
	name: 'seguimientoOfertasDetalle',
	data: () => ({
		statesIds,
		optionsPieChart: {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
                position: 'left',
				align: 'center',
				fullSize: false,
				labels: {
					font: {
					size: 12
					},
					padding: 10
				},
				maxWidth: 9999
            },
        },
		headers: [
			{ text: 'Presupuesto', value: 'offerId' },
			{ text: 'Fecha', value: 'created_date' },
			{ text: 'SDFID', value: 'sfid' },
			{ text: 'Comercial', value: 'usuario' },
			{
				text: 'Cliente',
				value: 'cliente',
				width: '250px',
				align: 'center',
			},
			{ text: 'Telefono', value: 'telefono' },
			{ text: 'NIF', value: 'nif' },
			{ text: 'Segmento', value: 'segmento_vf' },
			{ text: 'C.P.', value: 'cod_postal' },
			{ text: 'Estado', value: 'estado' },
			{ text: 'Fecha SMART', value: 'vodafone_date' },
			{ text: 'Site ID', value: 'id_vodafone' },
			// { text: 'Color', value: 'color' },
			{ text: 'Nº OT', value: 'idOrden' },
			{ text: 'Estado OT', value: 'ot_status_text' },
			{ text: 'Fecha consulta OT', value: 'ot_lastupdate' },
			{ text: 'Nº Offer SMART', value: 'idOffer' },
			// { text: 'Id Estado', value: 'id_estado' },
			// { text: 'Pdv', value: 'pdv' },
		],
	}),
	components: {
		PieChart,
		OfferDetailBase,
	},
	methods: {
		formatDate,
		formatDateLarge,
		detailOfferDetail(item) {
            this.$store.dispatch('retailX/offerDetailOffer', item.offerId);
        },
		openDetailedView(item) {
			this.$store.dispatch('retailX/fetchOfferDetail', item.offerId);
			this.$store.commit('retailX/offerDialogOpen', true);
		},
		getRowClass(item) {
			return `${statesIds[item.id_estado]['color']} lighten-3`;
		},
	},
	computed: {
		filteredOffers() {
			return this.getFiltersByStatesId.length > 0 ?
				this.seguimientoOfertasDetalle.filter(item => this.getFiltersByStatesId.some((it) => it === item.estado)) :
				this.seguimientoOfertasDetalle;
		},
		pieData() {
			let data = {}
			
			this.filteredOffers.forEach(element => {
				if(element.estado) {
					if (data[element.estado]) {
						data[element.estado] += 1;
					} else {
						data[element.estado] = 1;
					}
				}
			});

			let colors = Object.keys(data).map((key) => Object.values(statesIds).find((item) => item.text === key)?.pastelHexColor);	
			

			return {
				labels: Object.keys(data),
				datasets: [
					{
						label: Object.keys(data),
						data: Object.values(data),
						backgroundColor: colors,
						hoverOffset: 4,
					},
				],
			};
		},
		...mapState('retailX', {
			seguimientoOfertasDetalle: (state) =>
				state.seguimientoOfertasDetalle,
		}),
		...mapState({
			search: (state) => state.util.navBarSearchField,
		}),
		...mapGetters('retailX', {
			getFiltersByStatesId: 'getFiltersByStatesId',
		}),
	},
	beforeCreate() {
		//this.$store.dispatch('retailX/fetchAll');
	},
};
</script>